import React from "react";
import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="lt-footer">
      <button
        type="button"
        className="lt-footer__top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="กลับขึ้นด้านบน"
      >
        ▲
      </button>

      <div className="lucid-container">
        <div className="lt-footer__grid">
          <div>
            <div className="lt-footer__brand">
              <span className="lt-brand__mark">LT</span>
              <span className="lt-brand__text" style={{ color: "#fff", fontWeight: 800 }}>
                LucidTopup
                <span>Top-up game</span>
              </span>
            </div>
            <h4>เกี่ยวกับเรา</h4>
            <p>
              LucidTopup ให้บริการเติมเกมออนไลน์ เติมเงินมือถือ และจำหน่ายบัตรเติมเงินด้วยระบบอัตโนมัติตลอด 24 ชั่วโมง
              เราเป็นเพียงตัวแทนจำหน่ายเท่านั้น ไม่มีส่วนเกี่ยวข้องกับองค์กรหรือบุคคลใดที่แอบอ้างใช้ชื่อบัญชีธนาคารของร้าน
            </p>
            <p>
              เครดิตในเว็บไซต์ใช้สำหรับซื้อสินค้าภายในเว็บไซต์เท่านั้น โปรดระวังมิจฉาชีพแอบอ้างบัญชีเราเพื่อหลอกให้ผู้อื่นจ่ายค่าสินค้าแทน
            </p>
          </div>

          <div>
            <h4>ติดต่อเรา</h4>
            <ul>
              <li>🏢 95/151 ต.เหมือง อ.เมือง จ.ชลบุรี 20130</li>
              <li>
                📞 <a href="tel:0929811596">092-981-1596</a>
              </li>
              <li>
                ✉️ <a href="mailto:lucidtopup@gmail.com">lucidtopup@gmail.com</a>
              </li>
              <li>💬 @lucidtopup</li>
            </ul>
            <p style={{ marginTop: 14 }}>
              <Link to="/policy">นโยบายความเป็นส่วนตัว</Link>
            </p>
          </div>

          <div>
            <h4>เมนูลัด</h4>
            <ul>
              <li>
                <Link to="/topup/game">เติมเกม</Link>
              </li>
              <li>
                <Link to="/topup/mobile">เติมเงินมือถือ</Link>
              </li>
              <li>
                <Link to="/topup/card">บัตรเติมเงิน</Link>
              </li>
              <li>
                <Link to="/promotions">โปรโมชั่น</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="lt-footer__copy">© 2026 LucidTopup co., ltd. All rights reserved</div>
      </div>
    </footer>
  );
}
